.e0{padding:0.5rem;}